import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { QuestionListItem } from './Question/QuestionListItem';
import { QuestionForm } from './QuestionForm/QuestionForm';
import { HeaderWrapper, ListContainer, HeaderWithButtonWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ContentH3, ParagraphSmall } from 'src/domains/layouts/shared/typography/Content.style';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const GlobalPage = observer(() => {
    const { promotionQuestionsState } = useAppStateContext();
    const { sortedQuestions, currentQuestion, showCreateNewForm, areQuestionsLoading } = promotionQuestionsState;

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <HeaderWrapper>
                        <HeaderWithButtonWrapper>
                            <ContentH3>Marketing</ContentH3>
                            <Button
                                isDisabled={areQuestionsLoading}
                                onClick={() => !areQuestionsLoading && showCreateNewForm(true)}
                            >
                                Add new
                            </Button>
                        </HeaderWithButtonWrapper>
                        <ParagraphSmall>A maximum of three questions active at one time</ParagraphSmall>
                    </HeaderWrapper>

                    <ListContainer areLoading={areQuestionsLoading}>
                        <Loader isActive={areQuestionsLoading} />
                        {sortedQuestions.map((questionObject) => {
                            return (
                                <QuestionListItem
                                    key={questionObject.id}
                                    question={questionObject}
                                />
                            );
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <QuestionForm key={`question-form-${currentQuestion?.id}`} />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
